export function initializeSlider() {

    jQuery('.slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        },
      ]
    });
  
}
